import { map } from "rxjs/operators";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import { TemplateSmsRawItem } from "./constants";

export const fetchTemplateSmsRequestService = () => {
  return GET(`admin/notifications/template/sms`).pipe(
    map((response: any) => response)
  );
};

export const updateTemplateSmsRequestService = (
  operation: TemplateSmsRawItem
) => {
  const temp = { ...operation, id: operation.uniqueId };
  return PUT(`admin/notifications/template/sms`, [temp]).pipe(
    map((response: any) => response)
  );
};
